import React, { useEffect, useState } from "react";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import usePrivateLink from "../config/usePrivateLink";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { imgBaseUrl } from "../../api/api";
import { districtsList, statesList } from "../../api/Locations";
import { staffPasswordUpdate, StaffUpdates } from "../../api/Staff";
import SettingLayout from "./SettingLayout";

export default function Profile() {
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState("");
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [preview, setPreview] = useState(null);
  const [showPassword, setShowPassword] = useState({
    old: false,
    new: false,
    new_confirm: false,
  });

  useEffect(() => {
    setUserData(JSON.parse(localStorage.getItem("user_data") ?? "{}"));
  }, [loading]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUpdateUserData = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await StaffUpdates(formData);
      if (response.data.status === true) {
        localStorage.setItem("user_data", JSON.stringify(response.data.data));
        setUserData(response.data.data);
        setPreview(false);
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };
  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await staffPasswordUpdate(formData);

      if (response.data.status === true) {
        e.target.reset();
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getStates = async () => {
    setLoading(true);
    try {
      const response = await statesList();
      if (response.data.status === true) {
        setStates(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getDistricts = async (state = null) => {
    setLoading(true);
    try {
      let addUrl = "";
      if (state) addUrl += `&state=${state}`;
      const response = await districtsList(addUrl);
      if (response.data.status === true) {
        setDistricts(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getStates();
    getDistricts();
  }, []);
  useEffect(() => {
    if (userData?.state) {
      getDistricts(userData?.state);
    }
  }, [userData?.state]);

  const hasAccess = usePrivateLink();

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <SettingLayout />
                  <div className="col-12">
                    <div className="row">
                      <div className="col-md-8">
                        <div className="card mb-6">
                          <div className="card-body">
                            <form
                              className="row g-4"
                              onSubmit={handleUpdateUserData}
                            >
                              <div className="col-4">
                                <img
                                  src={imgBaseUrl + userData?.img}
                                  alt="IMG"
                                  className="w-100"
                                />
                              </div>
                              <div className="col-8 d-flex gap-3">
                                <div className="">
                                  <label
                                    htmlFor="img"
                                    className="btn btn-primary btn-sm"
                                  >
                                    <i className="ri-upload-2-line me-2" />{" "}
                                    Update Image
                                    <input
                                      type="file"
                                      id="img"
                                      name="img"
                                      hidden
                                      accept="image/*"
                                      capture="environment"
                                      onChange={handleFileChange}
                                    />
                                  </label>
                                </div>
                                {preview && (
                                  <div className="">
                                    <img
                                      src={preview}
                                      alt="Img Preview"
                                      className="rounded-3"
                                      style={{
                                        maxWidth: "100px",
                                        maxHeight: "100px",
                                      }}
                                    />
                                  </div>
                                )}
                              </div>

                              <div className="col-12">
                                <input
                                  className="form-control"
                                  type="hidden"
                                  id="id"
                                  name="id"
                                  value={userData?.id}
                                />
                                <input
                                  className="form-control"
                                  type="hidden"
                                  id="registration_no"
                                  name="registration_no"
                                  value={userData?.registration_no}
                                />
                                <div className="form-floating form-floating-outline">
                                  <input
                                    className="form-control input-uppercase"
                                    type="text"
                                    id="name"
                                    name="name"
                                    defaultValue={userData?.name}
                                  />
                                  <label htmlFor="name"> Name</label>
                                </div>
                              </div>

                              <div className="col-12">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    className="form-control"
                                    type="email"
                                    id="email"
                                    name="email"
                                    defaultValue={userData?.email}
                                  />
                                  <label htmlFor="email">Email</label>
                                </div>
                              </div>
                              <div className="col-12">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="number"
                                    className="form-control"
                                    id="mobile"
                                    name="mobile"
                                    defaultValue={userData?.mobile}
                                  />
                                  <label htmlFor="mobile">Mobile No</label>
                                </div>
                              </div>
                              <div className="col-12">
                                <div className=" form-floating form-floating-outline ">
                                  <select
                                    name="gender"
                                    id="gender"
                                    className="form-select"
                                  >
                                    <option
                                      value="Male"
                                      selected={userData?.gender === "Male"}
                                    >
                                      Male
                                    </option>
                                    <option
                                      value="Female"
                                      selected={userData?.gender === "Female"}
                                    >
                                      Female
                                    </option>
                                    <option
                                      value="Other"
                                      selected={userData?.gender === "Other"}
                                    >
                                      Other
                                    </option>
                                  </select>
                                  <label htmlFor="gender">Gender</label>
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="form-floating form-floating-outline">
                                  <textarea
                                    className="form-control input-uppercase"
                                    type="text"
                                    id="village"
                                    name="village"
                                    defaultValue={userData?.village}
                                  />
                                  <label htmlFor="village">Village/Town</label>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    name="state"
                                    id="state"
                                    className="form-select"
                                    value={userData?.state || ""}
                                    onChange={(e) =>
                                      setUserData({
                                        ...userData,
                                        state: e.target.value,
                                      })
                                    }
                                  >
                                    <option value="" selected disabled>
                                      Select State
                                    </option>
                                    {states?.map((state, i) => (
                                      <option value={state.name}>
                                        {state.name}
                                      </option>
                                    ))}
                                  </select>

                                  <label htmlFor="state">Select State</label>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    name="district"
                                    id="district"
                                    className="form-select"
                                    value={userData?.district || ""}
                                    onChange={(e) =>
                                      setUserData({
                                        ...userData,
                                        district: e.target.value,
                                      })
                                    }
                                  >
                                    <option value="" selected disabled>
                                      Select District
                                    </option>
                                    {districts?.map((district, i) => (
                                      <option value={district.name}>
                                        {district.name}
                                      </option>
                                    ))}
                                  </select>

                                  <label htmlFor="district">
                                    Select District
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    className="form-control"
                                    type="number"
                                    id="pincode"
                                    name="pincode"
                                    defaultValue={userData?.pincode}
                                  />
                                  <label htmlFor="pincode">Pin Code</label>
                                </div>
                              </div>
                              <div className="col-md-12 text-end">
                                {hasAccess("/profile/update") && (
                                  <button
                                    type="submit"
                                    className="btn btn-primary "
                                  >
                                    Save changes
                                  </button>
                                )}
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="card">
                          <div className="card-body">
                            <h5 className="">Change Password</h5>

                            <form
                              className="row g-4"
                              onSubmit={handleUpdatePassword}
                            >
                              <input
                                className="form-control"
                                type="hidden"
                                id="id"
                                name="id"
                                value={userData?.id}
                              />
                              <div className="col-12">
                                <div className="input-group input-group-merge">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      className="form-control"
                                      type={
                                        showPassword?.old ? "text" : "password"
                                      }
                                      name="currentPassword"
                                      id="currentPassword"
                                      placeholder="Current Password"
                                    />
                                    <label htmlFor="currentPassword">
                                      Current Password
                                    </label>
                                  </div>
                                  <span
                                    className="input-group-text cursor-pointer"
                                    onClick={() =>
                                      setShowPassword((pre) => ({
                                        ...pre,
                                        old: !pre?.old,
                                      }))
                                    }
                                  >
                                    {showPassword?.old ? (
                                      <i className="ri-eye-line ri-20px" />
                                    ) : (
                                      <i className="ri-eye-off-line ri-20px" />
                                    )}
                                  </span>
                                </div>
                              </div>
                              <div className="col-12">
                                <div className="input-group input-group-merge">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      className="form-control"
                                      type={
                                        showPassword?.new ? "text" : "password"
                                      }
                                      name="newPassword"
                                      id="newPassword"
                                      placeholder="New Password"
                                    />
                                    <label htmlFor="newPassword">
                                      New Password
                                    </label>
                                  </div>
                                  <span
                                    className="input-group-text cursor-pointer"
                                    onClick={() =>
                                      setShowPassword((pre) => ({
                                        ...pre,
                                        new: !pre?.new,
                                      }))
                                    }
                                  >
                                    {showPassword?.new ? (
                                      <i className="ri-eye-line ri-20px" />
                                    ) : (
                                      <i className="ri-eye-off-line ri-20px" />
                                    )}
                                  </span>
                                </div>
                              </div>
                              <div className="col-12">
                                <div className="input-group input-group-merge">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      className="form-control"
                                      type={
                                        showPassword?.new_confirm
                                          ? "text"
                                          : "password"
                                      }
                                      name="newPassword_confirmation"
                                      id="newPassword_confirmation"
                                      placeholder="Confirm New Password"
                                    />
                                    <label htmlFor="newPassword_confirmation">
                                      Confirm New Password
                                    </label>
                                  </div>
                                  <span
                                    className="input-group-text cursor-pointer"
                                    onClick={() =>
                                      setShowPassword((pre) => ({
                                        ...pre,
                                        new_confirm: !pre?.new_confirm,
                                      }))
                                    }
                                  >
                                    {showPassword?.new_confirm ? (
                                      <i className="ri-eye-line ri-20px" />
                                    ) : (
                                      <i className="ri-eye-off-line ri-20px" />
                                    )}
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-12 text-end">
                                {hasAccess("/profile/update") && (
                                  <button
                                    type="submit"
                                    className="btn btn-primary "
                                  >
                                    Save changes
                                  </button>
                                )}
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
